let $ = jQuery.noConflict(),
	devMode,
	body,
    firstLoad = true,
	mobileCheck = false,
	currentY,
	scrollBar,
	pageTransition,
	barbaInitialized,
	resizeCallbacks = [],
	mobileResizeCallbacks = [],
	barbaCallbacks = [],
	hasTouch = 'ontouchstart' in window,
	mouseAnimation,
	gallery;

window.currentY = 0;

$(function () {
	initStarterKit();

	// Composants Mobile & Desktop
	new Nav();
	new AnimationTitle();
	new AnimationList();
	new ArchiveJewel();
	new ContactMap();
	gallery = new Gallery();
	new DrawGallery();
	new IsoTope();
	new RelookingGallery();
	new SingleJewel();
	new Sizer();
	new Youtube();
	new WorkshopGallery();
    new Search();
	BlockCollapse.init();

	if (mobileCheck.isMobile) {
		// Composants Mobile uniquement
	} else {
		// Composants Desktop uniquement
        new AnimationHome();
        new Diamond3D();
        // new Particles();
        mouseAnimation = new Mouse();
        new MouseParallax();
        new Parallax();
	}
});

function initStarterKit() {
	body = $('body');
	mcubeDebug();
	mobileCheck = new MobileCheck();
	new ResizeEvents();
	new SmoothScroll();
    pageTransition = new CustomPageTransition();
	new BasePageTransition();
	new AppearOnHover();
	new AppearOnScroll();
	new DataLink();
	new DiamondPin();
	new Forms();
	new GDPR();
	new InitMatchHeight();
	new MadeByMcube();
}

function scrollListener(newY) {
	if (window.diamond) {
		window.diamond.onScroll(currentY);
	}
}